// // // import React, { useRef, useState } from "react";
// // // import { calender_icon } from "../../assets/img";

// // // const DateRange1 = ({ fromDate, setFromDate }) => {
// // //   const [fromDates, setFormDates] = useState("");
// // //   const [toDate, setToDate] = useState("");

// // //   const fromDateRef = useRef(null);
// // //   const toDateRef = useRef(null);
// // //   console.log("fromDate", fromDate);
// // //   const openFromDatePicker = () => {
// // //     if (fromDateRef.current) {
// // //       fromDateRef.current.showPicker?.() || fromDateRef.current.click();
// // //     }
// // //   };

// // //   return (
// // //     <div className="d-flex ac-jb gap-2">
// // //       {/* From Date */}
// // //       <div className="roles-bg rounded-2 mt-0 px-2 py-1 d-flex ac-js">
// // //         <img
// // //           src={calender_icon}
// // //           className="calender-icon me-2"
// // //           alt="calendar"
// // //           onClick={openFromDatePicker}
// // //           style={{ cursor: "pointer" }}
// // //         />
// // //         <div style={{ width: "115px" }}>
// // //           <p className="f3 fs-xs-10 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14">
// // //             From Range:
// // //           </p>
// // //           <input
// // //             ref={fromDateRef}
// // //             type="date"
// // //             value={fromDates}
// // //             onChange={(e) => {
// // //               setFromDate?.(e.target.value);
// // //               setFormDates(e.target.value);
// // //             }}
// // //             className="border-0 w-100"
// // //             placeholder="From Date"
// // //           />
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default DateRange1;

// // import React, { useState } from "react";
// // import DatePicker from "react-datepicker";
// // import "react-datepicker/dist/react-datepicker.css";
// // import { calender_icon } from "../../assets/img";

// // const DateRange1 = ({ fromDate, setFromDate, holidays }) => {
// //   const [fromDates, setFromDates] = useState(null);
// //   const [toDate, setToDate] = useState(null);

// //   console.log("holidays", holidays);

// //   return (
// //     <div className="d-flex ac-jb gap-3">
// //       {/* From Date */}
// //       <div className="roles-bg rounded-2 mt-0 px-2 py-1 d-flex ac-js">
// //         <img
// //           src={calender_icon}
// //           className="calender-icon me-2"
// //           alt="calendar"
// //           style={{ cursor: "pointer" }}
// //           onClick={() =>
// //             document.querySelector(".from-datepicker input").focus()
// //           }
// //         />
// //         <div style={{ width: "150px" }}>
// //           <p className="f3 fs-xs-10 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14">
// //             From Date:
// //           </p>
// //           <DatePicker
// //             className="from-datepicker border-0 w-100"
// //             selected={fromDates}
// //             onChange={(date) => {
// //               setFromDates(date);
// //               setFromDate?.(date);
// //             }}
// //             highlightDates={holidays}
// //             selectsStart
// //             startDate={fromDates}
// //             endDate={toDate}
// //             placeholderText="Select start date"
// //           />
// //         </div>
// //       </div>

// //       {/* To Date */}
// //       {/* <div className="roles-bg rounded-2 mt-0 px-2 py-1 d-flex ac-js">
// //         <img
// //           src={calender_icon}
// //           className="calender-icon me-2"
// //           alt="calendar"
// //           style={{ cursor: "pointer" }}
// //           onClick={() => document.querySelector(".to-datepicker input").focus()}
// //         />
// //         <div style={{ width: "150px" }}>
// //           <p className="f3 fs-xs-10 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14">
// //             To Date:
// //           </p>
// //           <DatePicker
// //             className="to-datepicker border-0 w-100"
// //             selected={toDate}
// //             onChange={(date) => setToDate(date)}
// //             highlightDates={holidays}
// //             selectsEnd
// //             startDate={fromDates}
// //             endDate={toDate}
// //             minDate={fromDates} // prevents selecting before start
// //             placeholderText="Select end date"
// //           />
// //         </div>
// //       </div> */}
// //     </div>
// //   );
// // };

// // export default DateRange1;
// import React, { useEffect, useRef, useState } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { calender_icon } from "../../assets/img";
// import moment from "moment";

// const DateRange1 = ({ fromDate, setFromDate, holidays = [], fromDat }) => {
//   const [fromDates, setFromDates] = useState(
//     new Date().toISOString().split("T")[0]
//   );
//   const fromDateRef = useRef(null);

//   const holidayDates = holidays.map((d) => new Date(d).toDateString());
//   const today = new Date().toDateString();

//   // Function to assign a class to each day
//   const highlightWithStyle = (date) => {
//     const dateStr = date.toDateString();
//     if (holidayDates.includes(dateStr)) {
//       return "highlight-red"; // holidays
//     } else if (dateStr === today) {
//       return "highlight-today"; // current date
//     }
//     return undefined;
//   };
//   console.log("dateeee", fromDat, fromDates);
//   useEffect(() => {
//     setFromDates(fromDat);
//   }, [fromDat]);
//   return (
//     <>
//       <style>
//         {`
//           .highlight-red {
//             background-color: red !important;
//             color: white !important;
//             border-radius: 15%;
//           }
//           .highlight-today {
//             background-color: #adadad !important;
//             color: white !important;
//             border-radius: 15%;
//           }
//         `}
//       </style>

//       {/* <div className="d-flex ac-jb gap-3">
//         <div
//           className="roles-bg rounded-2 mt-0 px-2 py-1 d-flex ac-js"
//           // onClick={() => setFromDate()}
//         >
//           <img
//             src={calender_icon}
//             className="calender-icon me-2"
//             alt="calendar"
//             style={{ cursor: "pointer" }}
//             onClick={() => fromDateRef.current.setFocus()} // <-- open calendar

//             // onClick={() =>
//             //   document.querySelector(".from-datepicker input")?.focus()
//             // }
//           />
//           <div style={{ width: "150px" }}>
//             <p className="f3 fs-xs-10 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-13 fs-xxl-14">
//               From Date:
//             </p>
//             <DatePicker
//               className="from-datepicker border-0 w-100"
//               selected={fromDates}
//               onChange={(date) => {
//                 setFromDates(date);
//                 setFromDate?.(date);
//               }}
//               dayClassName={highlightWithStyle} // assign custom classes
//               selectsStart
//               startDate={fromDates}
//               placeholderText="Select start date"
//             />
//           </div>
//         </div>
//       </div> */}
//       <div className="d-flex ac-jb gap-3">
//         <div className="roles-bg rounded-2 mt-0 px-2 py-1 d-flex ac-js">
//           <img
//             src={calender_icon}
//             className="calender-icon me-2"
//             alt="calendar"
//             style={{ cursor: "pointer" }}
//             onClick={() => fromDateRef.current.setFocus()} // <-- open calendar
//           />

//           <div style={{ width: "150px" }}>
//             <p className="f3 fs-xs-10">From Date:</p>

//             <DatePicker
//               ref={fromDateRef} // <-- add ref here
//               className="from-datepicker border-0 w-100"
//               selected={fromDates}
//               // selected={moment(fromDates).format("DD/MM/YYYY")}
//               onChange={(date) => {
//                 setFromDates(date);
//                 setFromDate?.(date);
//               }}
//               dayClassName={highlightWithStyle}
//               selectsStart
//               startDate={fromDates}
//               placeholderText="Select start date"
//             />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default DateRange1;
import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { calender_icon } from "../../assets/img";
import moment from "moment";

const DateRange1 = ({ fromDate, setFromDate, holidays = [], fromDat }) => {
  const [fromDates, setFromDates] = useState(new Date());
  const fromDateRef = useRef(null);

  const holidayDates = holidays.map((d) => new Date(d).toDateString());
  const today = new Date().toDateString();

  // Function to assign a class to each day
  const highlightWithStyle = (date) => {
    const dateStr = date.toDateString();
    if (holidayDates.includes(dateStr)) {
      return "highlight-red"; // holidays
    } else if (dateStr === today) {
      return "highlight-today"; // current date
    }
    return undefined;
  };

  console.log("dateeee", fromDat, fromDates);

  // useEffect(() => {
  //   setFromDates(fromDat);
  // }, [fromDat]);

  return (
    <>
      <style>
        {`
          .highlight-red {
            background-color: red !important;
            color: white !important;
            border-radius: 15%;
          }
          .highlight-today {
            background-color: #adadad !important;
            color: white !important;
            border-radius: 15%;
          }
        `}
      </style>

      <div className="d-flex ac-jb gap-3">
        <div className="roles-bg rounded-2 mt-0 px-2 py-1 d-flex ac-js">
          <img
            src={calender_icon}
            className="calender-icon me-2"
            alt="calendar"
            style={{ cursor: "pointer" }}
            onClick={() => fromDateRef.current.setFocus()}
          />

          <div style={{ width: "150px" }}>
            <p className="f3 fs-xs-10">From Date:</p>

            <DatePicker
              ref={fromDateRef}
              className="from-datepicker border-0 w-100"
              selected={fromDates}
              dateFormat="dd/MM/yyyy"
              onChange={(date) => {
                setFromDates(date);
                setFromDate?.(date);
              }}
              dayClassName={highlightWithStyle}
              selectsStart
              startDate={fromDates}
              placeholderText="Select start date"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DateRange1;
